function openPreview(event, part, isVariant=false) {
  var toShown = $('#' + part.replace(' ', '-'));


  // console.log(part,'---', toShown, 'part')
  $(toShown).parent().find('a.d-block').removeClass('d-block').addClass('d-none');
  $(toShown).removeClass('d-none').addClass('d-block');
  if (isVariant == false) {
    var data_part = $(toShown).data('part');
    var data_partvalue = $(toShown).data('partvalue');
    var query = data_part + '=' + data_partvalue;
    var parts = [$(toShown).data('partvalue')]
    $(toShown).find('img').each(function () {
      if ($(this).data('part') && $(this).data('partvalue')) {
        parts.push($(this).data('partvalue'))
        query = query + '&' + $(this).data('part') + '=' + $(this).data('partvalue')
      }
    })
  
    var href = $(toShown).attr('href').split('?')[0];
    $(toShown).attr('href', href + '?parts=' + parts.join(","));
    $(toShown).closest('.grid__item').find('.card__heading a').attr('href', href + '?parts=' + parts.join(","));
  }


  // var grid_item = $(toShown).closest('.grid__item');
  // $(grid_item).find('product-variants-data condition-item').each(function() {
  //   if ($(this).data('part') == data_part && $(this).data('partvalue') == data_partvalue) {
  //     $(grid_item).find('.price').html($(this).data('price'));
  //     return;
  //   }
  // })

}

function previewLoaded(event, target) {

  var partvalue = $(target).closest('a').data('partvalue');
  var grid_item = $(target).closest('.grid__item');
  var frames = $(grid_item).find('product-parts-data data-item[data-lenid=""]');
  frames.sort((a, b) => $(a).data("order") - $(b).data("order"))
  var frames_length = Math.min(4, frames.length);

  // var frame_index = Math.min($(target).closest('a').parent().find('a').index($(target).closest('a')), frames_length - 1);

  if ($(target).hasClass('view1')) {
    for (let index = 0; index < frames_length; index++) {
      var frame_index = index;

      var view1_frame = frames.eq(frame_index).data('view1');
      var data_part = frames.eq(frame_index).data('part');
      var data_partvalue = frames.eq(frame_index).data('partvalue');
      if (view1_frame) {
        $(target).parent().prepend(`
        <img
        loading="lazy"
        src="`+ view1_frame + `"
        class="motion-reduce view1 frame"
        data-part="`+ data_part + `"
        data-partvalue="`+ data_partvalue + `"
        >
        `)
      }

      // updateRatio(event, target);

    }


  }
  if ($(target).hasClass('view3')) {

    for (let index = 0; index < frames_length; index++) {
      var frame_index = index;

      var view3_frame = frames.eq(frame_index).data('view3');
      if (view3_frame) {
        $(target).parent().prepend(`
        <img
        loading="lazy"
        src="`+ view3_frame + `"
        class="motion-reduce view3 frame">
        `)
      }
    }


  }
}
function updateRatio(event, target) {
  if ($(target).parent().find('img.view1:visible').length == 0) return
  if ($(target).parent().find('img.view1:visible').eq(0).height() == 0) {
    var ratio = 1;
  }
  else {
    ratio = $(target).parent().find('img.view1:visible').eq(0).width() / $(target).parent().find('img.view1:visible').eq(0).height();
  }
  if (!ratio || ratio == NaN) {
    ratio = '100%';
  }
  else {
    console.log('ratio', 1 / ratio, ratio)
    ratio = Math.round(100 / ratio);
    ratio = Math.min(ratio, 100);
    ratio = ratio + '%';
  }

  console.log('ratiofinal', ratio, target.nodeName.toLowerCase)
  if ($(target).parent().find('.view3').length) {
    // $(target).closest('.card').css('--ratio-percent', ratio);
  }
  $(target).closest('.card__inner').css('--ratio-percent', ratio);
}